// ookami-product-card per-card reveal: viewport 進入で .is-active 付与
// 遅延ロードされるカード（related-products 等）にも MutationObserver で追従
(function () {
  var io = null;
  function getObserver() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              entry.target.classList.add('is-visible');
            });
          });
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    return io;
  }

  function observe(card) {
    if (!card || card.dataset.ookamiObserved === '1') return;
    card.dataset.ookamiObserved = '1';
    var ob = getObserver();
    if (ob) {
      ob.observe(card);
    } else {
      card.classList.add('is-visible');
    }
  }

  function scanAll(root) {
    (root || document).querySelectorAll('.ookami-product-card').forEach(observe);
  }

  function init() {
    scanAll();
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('ookami-product-card')) {
            observe(node);
          } else if (node.querySelectorAll) {
            scanAll(node);
          }
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
